// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { updateBulkEditState } from 'redux/modules/bulkEdit'

const toggleAllVisiblePaths = () => (dispatch, getState) => {
  const { bulkEdit } = getState()
  const highlightedPathIds = bulkEdit.get('highlightedPathIds')
  const visiblePathIds = bulkEdit.get('visiblePathIds')

  // if all paths are highlighted, deselect them all,
  // otherwise highlight them all
  return dispatch(updateBulkEditState({
    highlightedPathIds: (
      highlightedPathIds.size === visiblePathIds.size
        ? highlightedPathIds.clear()
        : visiblePathIds
    ),
  }))
}

export default toggleAllVisiblePaths
